import React, { useState } from "react";
import {
  View,
  Text,
  Image,
  Dimensions,
  Animated,
  TouchableOpacity,
  StyleSheet,
  ScrollView,
  FlatList,
  TextInput,
} from "react-native";
import Header from "../../component/header";
import Background from "../../component/background";
import FinalEntryAdd from "../../component/finalEntryAdd";
import { FontAwesome, Entypo, Ionicons } from "@expo/vector-icons";
import * as FileSystem from "expo-file-system";
const { width, height } = Dimensions.get("window");
// import {} from "base64-arraybuffer";

export default function index({ navigation, route }) {

  console.log('TYPE >>' , route.params.type);
  
  async function getBase64Image() {
    const imageUrl = "http://i.imgur.com/XP2BE7q.jpg";
    const response = await fetch(imageUrl);
    // This will be the blob data that you will have to store inside your SQLite DB
    const blob = await response.arrayBuffer();
    console.log("base64", arrayBufferToBase64(blob));
    // console.log(_arrayBufferToBase64(blob));
  }

  const arrayBufferToBase64 = (buffer) => {
    let binary = "";
    let bytes = new Uint8Array(buffer);
    let len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  };

  getBase64Image();

  return (
    <View style={styles.container}>
      <Header
        onPressHome={() => {
          navigation.navigate("HomeUser");
        }}
        onPressCompetition={() => {
          navigation.navigate("CompetitionUser");
        }}
        onPressAthlete={() => {
          navigation.navigate("AthleteUser");
        }}
        onPressLogout={() => {
          navigation.navigate("Login");
        }}
        backgroundColorCompetition="#FFFFFF"
        User
        navigation={navigation}
      />
      <ScrollView>
        <View>
          <Background
            navigation={navigation}
            Title={`COMPETITIONS/${route.params.name}/FINAL ENTRY SUBMIT`}
          />
          <FinalEntryAdd route={route} navigation={navigation} />
        </View>
      </ScrollView>
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#CCE4FF",
    flexDirection: "row",
  },
});
